export default __webpack_public_path__ + "static/media/ijapps.b6309f7b.png";